/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { isEmpty } from "./utils";

const TIMING_KEYS = {
  SLIDER_START: "SLIDER_START",
  SLIDER_STRUCT_COMPLETE: "SLIDER_STRUCT_COMPLETE",
  SLIDER_END: "SLIDER_END"
};

function markTiming(markName) {
  if (!markName || !TIMING_KEYS[markName]) {
    console.warn("Mark identifier not defined");
    return false;
  }
  global && global.performance && global.performance.mark(markName);
}

function computeTimings(markingsArray = []) {
  let performanceMarks = [];
  if (isEmpty(markingsArray)) {
    console.warn(`Mark identifier's array cannot be empty`);
    return false;
  }
  if (global && global.performance) {
    global.performance.measure.apply(global.performance, markingsArray);
    performanceMarks = global.performance.getEntriesByType("mark");
    global.performance.clearMarks.apply(global.performance, markingsArray);
  }
  return performanceMarks;
}

function clearMarks(mark) {
  if (!mark || !TIMING_KEYS[mark]) {
    console.warn(`mark cannot be empty`);
    return false;
  }
  global && global.performance && global.peformance.clearMarks(mark);
}

function clearMeasures(measure) {
  if (!measure || !TIMING_KEYS[measure]) {
    console.warn(`measure cannot be empty`);
    return false;
  }
  global && global.performance && global.performance.clearMeasures(measure);
}

export { markTiming, computeTimings, clearMarks, clearMeasures, TIMING_KEYS };
